import classNames from "classnames"
import { formatCurrency } from "../../utils/formatNumber"
import {
  estimateMonthlyPayment,
  estimateTotalToPay,
  MX_ESTIMATED_PAYMENT_MONTHS
} from "../../utils/estimateMonthlyPayment"
import "./estimated-payment.sass"

interface IEstimatedPaymentProps {
  amount: number
  months?: number
  markup?: number
  currency?: string
  currencyPosition?: "prefix" | "suffix"
  label?: string
  amountLabel?: string
  totalLabel?: string
  disclaimer?: string
  className?: string
}

export function EstimatedPayment({
  amount,
  months = MX_ESTIMATED_PAYMENT_MONTHS,
  markup,
  currency = "$",
  currencyPosition = "prefix",
  label = "Cuota estimada",
  amountLabel = "Cantidad",
  totalLabel = "Total a pagar",
  disclaimer,
  className
}: IEstimatedPaymentProps) {
  const payment = estimateMonthlyPayment(amount, months, markup)
  const total = estimateTotalToPay(amount, months, markup)

  return (
    <div className={classNames("estimated-payment-wrap", className)}>
      <div className="estimated-payment" aria-live="polite">
        <div className="estimated-payment__col">
          <span className="estimated-payment__label">{amountLabel}</span>
          <span className="estimated-payment__value">
            {formatCurrency(amount, currency, currencyPosition)}
          </span>
        </div>
        <div className="estimated-payment__col estimated-payment__col--accent">
          <span className="estimated-payment__label">{label}</span>
          <span className="estimated-payment__value">
            {formatCurrency(payment, currency, currencyPosition)}
          </span>
        </div>
        <div className="estimated-payment__col">
          <span className="estimated-payment__label">{totalLabel}</span>
          <span className="estimated-payment__value">
            {formatCurrency(total, currency, currencyPosition)}
          </span>
        </div>
      </div>
      {disclaimer && <p className="estimated-payment__disclaimer">{disclaimer}</p>}
    </div>
  )
}
